import { io } from "socket.io-client";
import { API_URL } from "@/services/constants";

const stored = localStorage.getItem("user_detail");
const details = stored ? JSON.parse(stored) : null;
const URL = API_URL ?? "";

export const socket = io(`${URL}/messages?userId=${details?.id}`, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  secure: URL.startsWith("https"),
  autoConnect: true,
});
